<template>
  <div class="d2-footer">
    <p class="d2-footer-copyright">
      © CopyRight 2020-2020,<a
        target="black"
        class="d2-footer-copyright-link"
        href="http://beian.miit.gov.cn/"
        >豫ICP备17015625号-4</a
      >
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  created() {},
  methods: {},
}
</script>
<style scoped>
.d2-footer {
  height: 30px;
  display: flex;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
}
p.d2-footer-copyright {
  display: inline;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 1.08px;
  text-align: center;
}
a.d2-footer-copyright-link {
  color: #333;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 1.08px;
  text-decoration: none;
}
</style>


// WEBPACK FOOTER //
// src/views/footer/footer.vue